export default __webpack_public_path__ + "static/media/Interbold.bb91cbba.ttf";